import { useNavigate } from "react-router-dom";
import { CustomButton2, CustomView } from "../../../../panel/components";

const Navigation = () => {
  const navigate = useNavigate();
  return (
    <CustomView.Row className="navigation">
      <CustomView.Column medium={10}>{""}</CustomView.Column>
      <CustomView.Column medium={2}>
        <CustomView.Row>
          <CustomView.Column medium={6}>
            <CustomButton2
              title={"ورود"}
              type="secondary"
              onClick={() => navigate("/panel/login")}
            />
          </CustomView.Column>
          <CustomView.Column medium={6}>
            <CustomButton2
              title={"ثبت نام"}
              type="secondary"
              onClick={() => navigate("/panel/sign-up")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Column>
    </CustomView.Row>
  );
};

export default Navigation;
